<template>
    <my-popup :visible.sync="show">
        <type-wrapper class="type-Q" padding>
            <template v-if="config.accesscode">
            	<type-grid row="11">
					<type-text type="title" size="9" padding="0">Access Code</type-text>
            	</type-grid>
            	<type-grid row="11" margin>
            		<type-input whitebackdrop v-model="code" placeholder=""></type-input>
            	</type-grid>
            </template>
            <template v-if="config.needemail">
            	<type-grid row="11">
					<type-text type="title" size="9" padding="0">Email</type-text>
            	</type-grid>
            	<type-grid row="11" margin>
            		<type-input whitebackdrop v-model="email" placeholder=""></type-input>
            	</type-grid>
            </template>
            <template v-if="config.needphone">
            	<type-grid row="11">
					<type-text type="title" size="9" padding="0">Mobile</type-text>
            	</type-grid>
            	<type-grid row="11" margin>
            		<type-input whitebackdrop v-model="mobile" placeholder=""></type-input>
            	</type-grid>
            </template>
            <template v-if="config.needphone === 3">
            	<type-grid row="11">
					<type-text type="title" size="9" padding="0">Verify Code</type-text>
            	</type-grid>
            	<type-grid row="12" margin>
            		<type-input whitebackdrop v-model="mobileVerifyCode" placeholder=""></type-input>
            	</type-grid>
            	<type-grid row="12" margin>
            		<type-button whitebackdrop border @click="getVerifyCode">{{ buttonText }}</type-button>
            	</type-grid>
            </template>
            <template>
            	<type-grid row="11" margin>
            		<type-button whitebackdrop border @click="submitData">确定</type-button>
            	</type-grid>
            </template>
        </type-wrapper>
    </my-popup>
</template>

<script>
	// 输入口令
	import mixin from '../mixin.js'
	export default {
		name: 'type-Q',
		mixins: [ mixin ],
		data() {
			return {
                update: true,
				show: true,
				code: '',
				email: '',
				mobile: '',
				countDown: -1,
				mobileVerifyCode: ''
			}
		},
		watch: {
			config: {
				handler(newValue) {
					if (newValue.accesscode === '' && [0, 1].indexOf(newValue.needemail) > -1 && [0, 1].indexOf(newValue.needphone) > -1) {
						this.show = false;
					}
					// console.clear()
					// console.log(this.show, JSON.parse(JSON.stringify(this.config)));
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			verifyData() {
				if (this.config.accesscode) {
					if (this.code === '') {
						this.code === '00'
						//this.$message('Please enter code');
						//return false;
					}
					if (this.code !== this.config.accesscode) {
						this.$message('Wrong Code!');
						return false;
					}
				}
				if (((this.config.needemail === 1) && this.email) || (this.config.needemail === 2)) {
					let error = this.$verify.verifyEmail(this.email);
					if (error !== true) {
						this.$message(error);
						return false;
					}
				}
				if (((this.config.needphone === 1) && this.mobile) || ([2, 3].indexOf(this.config.needphone) > -1)) {
					let error = this.$verify.verifyMobile(this.mobile);
					if (error !== true) {
						this.$message(error);
						return false;
					}
				}
				return true;
			},
			async submitData() {
                if (this.verifyData()) {
                    if (this.config.needemail || this.config.needphone) {
                        if (this.config.needphone === 3) {
                            if (this.mobileVerifyCode) {
                                const { status } = await this.$http.user.check_mobile_verifycode({
									mobile: this.mobile,
									verifycode: this.mobileVerifyCode
								});
                                if (status !== 'success') {
                                    // this.$message('验证码不正确，请重新输入');
                                    return;
                                }
                            } else {
                                this.$message('Please enter verification code');
                                return;
                            }
                        }
                    }
                    const data = {
                    	email: this.email,
                    	mobile: this.mobile
                    };
                    const content = Object.keys(data).map(key => `${key}=${data[key]}`).join('&');
                    const reportResult = await this.$http.user.report_bug(content);
                    if (reportResult.status === 'success') {}
                    // console.log('上传数据', JSON.parse(JSON.stringify(data)))
                    this.$userInfo.setData(data);
                    this.show = false;
                }
			},
			getVerifyCode() {
				if ((this.config.needphone === 3) && (this.countDown === -1)) {
					this.$http.user.send_mobile_verifycode(this.mobile).then(res => {
						if (res.status === 'success') {
							this.$message('Verification Code Sent.');
							this.countDown = 60;
							let timer = setInterval(() => {
								this.countDown -= 1;
								if (this.countDown === 0) {
									clearInterval(timer);
									this.countDown = -1;
								}
							}, 1000);
						}
					});
				}
			}
		},
		computed: {
			config() {
				let accesscode = '';	// 决定整个弹窗是否显示
				let needemail = 0;		// 0不需要1可选2必选
				let needphone = 0;		// 0不需要1可选2必选3必选+后台验证
				if (this.showData.tag) {
					let data = this.showData.tag.split(/\,|\，/g).filter(Boolean).forEach(v => {
						if (v.indexOf('accesscode=') > -1) {
							accesscode = v.replace('accesscode=', '');
						}
						if (v.indexOf('needemail=') > -1) {
							needemail = v.replace('needemail=', '');
							needemail = Number(needemail) || 0;
							needemail = [0, 1, 2].indexOf(needemail) > -1 ? needemail : 0;
						}
                        if (v.indexOf('needphone=') > -1) {
							needphone = v.replace('needphone=', '');
							needphone = Number(needphone) || 0;
							needphone = [0, 1, 2, 3].indexOf(needphone) > -1 ? needphone : 0;
						}
					});
				}
				return {
					accesscode,
					needemail,
					needphone
				};
			},
			buttonText() {
				return this.countDown === -1 ? '获取验证码' : `${this.countDown}秒后重新获取`;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-Q{
        width: calc(100vw - 90px);
        max-width: 400px;
        min-width: 240px;
		background-color: #FFFFFF;
	}
    @media screen and (min-height: 760px){}
    @media screen and (max-height: 759px){
        .type-Q{
            max-height: calc(100vh - 180px);
            overflow-x: hidden;
            overflow-y: scroll;
            scrollbar-width: none;
            scrollbar-color: transparent transparent;
            background-color: red;
            &::-webkit-scrollbar{
            	width: 0px;
            }
            &::-webkit-scrollbar-thumb{
            	border-radius: 0px;
            	background-color: transparent;
            }
            &::-webkit-scrollbar-button{
            	display: none;
            }
            &::-webkit-scrollbar-track{
            	background-color: transparent;
            }
        }
    }
</style>
